import script from "./ImpersonationBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImpersonationBanner.vue?vue&type=script&setup=true&lang=ts"

import "./ImpersonationBanner.vue?vue&type=style&index=0&id=94b65e9e&lang=scss"

const __exports__ = script;

export default __exports__